import { DEFAULT_POST_INTAKE_SUBJECT } from '@common/constants';
import { Box, Divider, Link, Typography } from '@mui/material';
import { useChangedFlag } from '@/hooks/util';
import { theme } from '@/theme';
import { convertToHtml } from '@/utils';

interface Props {
    isPostIntakeEnable?: boolean;
    postIntakeSubject?: string;
    textAfterSubmitIntakeForClient: string;
    signature: string;
}

export default function PostEmailTemplatePreview({
    isPostIntakeEnable = false,
    postIntakeSubject = '',
    textAfterSubmitIntakeForClient,
    signature,
}: Props) {
    const hasSignatureChanged = useChangedFlag(signature);

    return (
        <Box
            sx={{
                borderRadius: '8px',
                border: `1px solid ${theme.palette.neutral.borderColor}`,
                backgroundColor: 'neutral.white',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                height: 'fit-content',
                width: '100%',
                margin: '10px 32px 32px 0px',
            }}
        >
            <Box>
                <Typography variant="h2">Post intake template preview</Typography>
                <Typography variant="body2" sx={{ marginTop: '8px' }}>
                    This is a preview of an email that your clients will see in their inbox.
                </Typography>
            </Box>
            <Divider orientation="horizontal" />
            <Box
                sx={{
                    borderRadius: '4px',
                    border: '1px solid #E0E3E5',
                    background: '#F0F5FD',
                    display: 'flex',
                    flexDirection: 'column',
                    '& > *': {
                        padding: '16px',
                    },
                    wordWrap: 'break-word',
                    overflowWrap: 'anywhere',
                }}
            >
                <Typography variant="h3" className={postIntakeSubject} sx={{ maxWidth: '549px' }}>
                    {isPostIntakeEnable ? postIntakeSubject : DEFAULT_POST_INTAKE_SUBJECT}
                </Typography>
                <Typography variant="body1" color="text.primary">
                    Hi [Client first name],
                </Typography>

                {isPostIntakeEnable && (
                    <Box>
                        <Typography
                            variant="body1"
                            sx={{
                                color: 'text.primary',
                                maxWidth: '549px',
                            }}
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: convertToHtml(textAfterSubmitIntakeForClient),
                                }}
                            ></span>
                        </Typography>
                    </Box>
                )}

                <Typography variant="body1" color="text.primary">
                    {isPostIntakeEnable
                        ? 'If you want to make any updates to your intake form, you can do so here:'
                        : 'We’ve received your intake form. If you want to make any updates, you can do so here:'}
                </Typography>
                <Box>
                    <Link
                        href="#"
                        variant="h3"
                        sx={{
                            color: theme.palette.primary.main,
                            cursor: 'pointer',
                            textDecoration: 'none',
                        }}
                    >
                        Intake form link
                    </Link>
                </Box>
                <Box>
                    <Typography
                        variant="body1"
                        sx={{ color: 'text.primary', maxWidth: '549px' }}
                        className={hasSignatureChanged ? 'activity-tracker' : ''}
                    >
                        <span dangerouslySetInnerHTML={{ __html: convertToHtml(signature) }}></span>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
